module.exports = __webpack_public_path__ + "static/img/home_active.5cf6948b.png";